import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import AppDelivery from 'delivery/AppDelivery'
import { configureStore } from 'core/redux/store'


// Initialize store
const store = configureStore(window.__INITIAL_STATE__)
const mountApp = document.getElementById('root')
const renderMethod = module.hot ? ReactDOM.render : ReactDOM.hydrate

renderMethod(
  <AppContainer>
    <AppDelivery store={store} />
  </AppContainer>,
  mountApp
)

// For hot reloading of react components
if (module.hot) {
  module.hot.accept('./AppDelivery', () => {
    // If you use Webpack 2 in ES modules mode, you can
    // use <App /> here rather than require() a <NextApp />.
    const NextApp = require('./AppDelivery').default // eslint-disable-line global-require
    renderMethod(
      <AppContainer>
        <NextApp store={store} />
      </AppContainer>,
      mountApp
    )
  })
}
